export const PAGE_SIZE = 10;

// Returns the items for one page, with the page number clamped to the valid range
export function paginate(items, page, size = PAGE_SIZE) {
  const pageCount = Math.max(1, Math.ceil(items.length / size));
  const current = Math.min(Math.max(1, page), pageCount);
  const start = (current - 1) * size;
  return { pageItems: items.slice(start, start + size), page: current, pageCount };
}

// Last 8 characters of an order ID; the full ID is shown on hover
export function shortOrderId(id) {
  return String(id || '').slice(-8);
}
